import React from 'react';
import { IndexRoute, Route } from 'react-router';
import App from './components/App';
import Dashboard from './components/Dashboard/Dashboard';
import Product from './components/ItemManagement/Product/Product';
import ProductHome from './components/ItemManagement/Product/ProductHome';
import ProductSearch from './components/ItemManagement/Product/ProductSearch';
import NewProductHome from './components/ItemManagement/Product/NewProductHome';
import ProductMainHome from './components/ItemManagement/Product/ProductMain/ProductMainHome';
import ProductMainEdit from './components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEdit';
import ProductMainEditGeneralInfoForm from './components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEditGeneralInfoForm';
import ProductMainEditPriceForm from './components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEditPriceForm';
import ProductMainEditLocation from './components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainLocation/ProductMainEditLocation';
import ProductMainEditFeature from './components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEditFeature';
import ProductMainEditImage from './components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEditImage';
import ProductSubHome from './components/ItemManagement/Product/ProductSub/ProductSubHome';
import ProductSubEdit from './components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEdit';
import ProductSubEditGeneralInfoForm from './components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEditGeneralInfoForm';
import ProductSubEditImage from './components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEditImage';
import ProductSubEditFeature from './components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEditFeature';
import Service from './components/ItemManagement/Service/Service';
import ServiceHome from './components/ItemManagement/Service/ServiceHome';
import FeatureClass from './components/ItemManagement/FeatureClass/FeatureClass';
import FeatureClassHome from './components/ItemManagement/FeatureClass/FeatureClassHome';
import Brand from './components/Brand/Brand';
import BrandHome from './components/Brand/BrandHome';
import NewBrandForm from './components/Brand/NewBrandForm';
import EditBrandForm from './components/Brand/EditBrandForm';
import Manufacturer from './components/Manufacturer/Manufacturer';
import ManufacturerHome from './components/Manufacturer/ManufacturerHome';
import NewManufacturerForm from './components/Manufacturer/NewManufacturerForm';
import EditManufacturerForm from './components/Manufacturer/EditManufacturerForm';
// Shop Management
import Shop from './components/ShopManagement/Shop/Shop';
import ShopHome from './components/ShopManagement/Shop/ShopHome';
// Contact Management
import Contact from './components/Contact/Contact';
import ContactHome from './components/Contact/ContactHome';
import SalesDue from './components/Contact/SalesDue';
import NewContact from './components/Contact/NewContact';
import ContactDetail from './components/Contact/ContactDetail/ContactDetail';
import ContactAddress from './components/Contact/ContactDetail/ContactAddress';
import ContactInvoice from './components/Contact/ContactDetail/ContactInvoice/ContactInvoice';
import ContactSaleInvoice from './components/Contact/ContactDetail/ContactInvoice/SaleInvoice';
import ContactSaleReturnInvoice from './components/Contact/ContactDetail/ContactInvoice/SaleReturnInvoice';
import ContactPurchaseInvoice from './components/Contact/ContactDetail/ContactInvoice/PurchaseInvoice';
import ContactExpenseInvoice from './components/Contact/ContactDetail/ContactInvoice/ExpensesInvoices';
import ContactFixedAssetsInvoices from './components/Contact/ContactDetail/ContactInvoice/FixedAssetsInvoices';
import ContactStock from './components/Contact/ContactDetail/ContactStock';
// Invoice management
import Purchase from './components/InvoiceManagement/Purchase/Purchase';
import PurchaseHome from './components/InvoiceManagement/Purchase/PurchaseHome';
import NewPurchase from './components/InvoiceManagement/Purchase/NewPurchase';
import EditPurchaseForm from './components/InvoiceManagement/Purchase/EditPurchaseForm';
import PurchaseInvoiceDetail from './components/InvoiceManagement/Purchase/PurchaseInvoiceDetail/PurchaseInvoiceDetail';
import PurchaseInvoiceDetailItem from './components/InvoiceManagement/Purchase/PurchaseInvoiceDetail/PurchaseInvoiceDetailItem';
import PurchaseInvoiceDetailPaymentHistory from './components/InvoiceManagement/Purchase/PurchaseInvoiceDetail/PurchaseInvoiceDetailPaymentHistory';
import UnpaidBill from './components/InvoiceManagement/Purchase/UnpaidBill';
import PurchaseUnAuthorized from './components/InvoiceManagement/Purchase/PurchaseUnAuthorized';
import PurchasePayBill from './components/InvoiceManagement/Purchase/PurchasePayment/PurchasePayBill';
import PurchaseReturn from './components/InvoiceManagement/PurchaseReturn/PurchaseReturn';
import PurchaseReturnHome from './components/InvoiceManagement/PurchaseReturn/PurchaseReturnHome';
import NewPurchaseReturn from './components/InvoiceManagement/PurchaseReturn/NewPurchaseReturn';
import Sale from './components/InvoiceManagement/Sale/Sale';
import SaleHome from './components/InvoiceManagement/Sale/SaleHome';
import NewSaleForm from './components/InvoiceManagement/Sale/NewSaleForm';
import EditSaleForm from './components/InvoiceManagement/Sale/EditSaleForm';
import SaleInvoiceDetailOfficialLayout from './components/InvoiceManagement/Sale/SaleInvoiceDetailOfficialLayout/SaleInvoiceDetailOfficialLayout.js';
import SaleInvoiceDetail from './components/InvoiceManagement/Sale/SaleInvoiceDetail/SaleInvoiceDetail';
import SaleInvoiceDetailItem from './components/InvoiceManagement/Sale/SaleInvoiceDetail/SaleInvoiceDetailItem';
import SaleInvoiceDetailPaymentHistory from './components/InvoiceManagement/Sale/SaleInvoiceDetail/SaleInvoiceDetailPaymentHistory';
import SaleDueBill from './components/InvoiceManagement/Sale/UnpaidBill';
import SaleKnownDueBill from './components/InvoiceManagement/Sale/UnknowUnpaidBill';
import SalePendingBill from './components/InvoiceManagement/Sale/PendingBill';
import SaleReceivePayment from './components/InvoiceManagement/Sale/SaleReceivePayment/SaleReceivePayment';
import SaleFullPaymentForm from './components/InvoiceManagement/Sale/SaleReceivePayment/FullPaymentForm';
import SalePartialPaymentForm from './components/InvoiceManagement/Sale/SaleReceivePayment/PartialPaymentForm';
import SalePrepaidReceive from './components/InvoiceManagement/Sale/SalePrepaidReceive/SalePrepaidReceive';
import SaleReturn from './components/InvoiceManagement/SaleReturn/SaleReturn';
import SaleReturnHome from './components/InvoiceManagement/SaleReturn/SaleReturnHome';
import NewSaleReturn from './components/InvoiceManagement/SaleReturn/NewSaleReturn';
import SaleReturnInvoiceDetail from './components/InvoiceManagement/SaleReturn/SaleReturnInvoiceDetails/SaleReturnInvoiceDetail';
import SaleReturnInvoiceDetailItem from './components/InvoiceManagement/SaleReturn/SaleReturnInvoiceDetails/SaleReturnInvoiceDetailItem';
import SaleReturnInvoiceDetailPaymentHistory from './components/InvoiceManagement/SaleReturn/SaleReturnInvoiceDetails/SaleReturnInvoiceDetailPaymentHistory';
import SaleReturnPayment from './components/InvoiceManagement/SaleReturn/SaleReturnPayment/SaleReturnPayBill';
import SaleReturnFullPaymentForm from './components/InvoiceManagement/SaleReturn/SaleReturnPayment/FullPaymentForm';
import SaleReturnPartialPaymentForm from './components/InvoiceManagement/SaleReturn/SaleReturnPayment/PartialPaymentForm';
import SaleReturnDueBill from './components/InvoiceManagement/SaleReturn/UnpaidBill';
import Expense from './components/InvoiceManagement/Expense/Expense';
import ExpenseHome from './components/InvoiceManagement/Expense/ExpenseHome';
import NewExpenseForm from './components/InvoiceManagement/Expense/NewExpenseForm';
import ExpenseDueBill from './components/InvoiceManagement/Expense/UnpaidBill';
import ExpenseInvoiceDetail from './components/InvoiceManagement/Expense/ExepnseInvoiceDetail/ExpenseInvoiceDetail';
import ExpenseInvoiceDetailItem from './components/InvoiceManagement/Expense/ExepnseInvoiceDetail/ExpenseInvoiceDetailItem';
import ExpenseInvoiceDetailPaymentHistory from './components/InvoiceManagement/Expense/ExepnseInvoiceDetail/ExpenseInvoiceDetailPaymentHistory';
import ExpensePayBill from './components/InvoiceManagement/Expense/ExpensePayment/ExpensePayBill';
import ExpenseFullPaymentForm from './components/InvoiceManagement/Expense/ExpensePayment/FullPaymentForm';
import ExpensePartialPaymentForm from './components/InvoiceManagement/Expense/ExpensePayment/PartialPaymentForm';
import FixedAsset from './components/InvoiceManagement/FixedAsset/FixedAsset';
import AllFixedAssets from './components/InvoiceManagement/FixedAsset/AllFixedAssets';
import FixedAssetHome from './components/InvoiceManagement/FixedAsset/FixedAssetHome';
import FixedAssetDueBill from './components/InvoiceManagement/FixedAsset/UnpaidBill';
import NewFixedAssetForm from './components/InvoiceManagement/FixedAsset/NewFixedAssetForm';
import FixedAssetInvoiceDetail from './components/InvoiceManagement/FixedAsset/FixedAssetInvoiceDetail/FixedAssetInvoiceDetail';
import FixedAssetInvoiceDetailItem from './components/InvoiceManagement/FixedAsset/FixedAssetInvoiceDetail/FixedAssetInvoiceDetailItem';
import FixedAssetInvoiceDetailPaymentHistory from './components/InvoiceManagement/FixedAsset/FixedAssetInvoiceDetail/FixedAssetInvoiceDetailPaymentHistory';
import FixedAssetPayBill from './components/InvoiceManagement/FixedAsset/FixedAssetPayment/FixedAssetPayBill';
import FixedAssetFullPaymentForm from './components/InvoiceManagement/FixedAsset/FixedAssetPayment/FullPaymentForm';
import FixedAssetPartialPaymentForm from './components/InvoiceManagement/FixedAsset/FixedAssetPayment/PartialPaymentForm';
import FindInvoice from './components/InvoiceManagement/FindInvoice/FindInvoice';
// OrderManagement
import Order from './components/OrderManagement/Order';
import OrderHome from './components/OrderManagement/OrderHome';
import OrderDetails from './components/OrderManagement/OrderDetails';
// Accounting
import JournalEntry from './components/AccountingManagement/JournalEntries/JournalEntry';
import JournalEntryHome from './components/AccountingManagement/JournalEntries/JournalEntryHome';
import NewJournalEntryForm from './components/AccountingManagement/JournalEntries/NewJournalEntryForm';
import ChartOfAccount from './components/AccountingManagement/ChartOfAccount/ChartOfAccount';
import ChartOfAccountHome from './components/AccountingManagement/ChartOfAccount/ChartOfAccountHome';
import NewEditChartOfAccountForm from './components/AccountingManagement/ChartOfAccount/NewEditChartOfAccountForm';
import TrialBalance from './components/AccountingManagement/TrialBalance/TrialBalance';
import TrialBalanceHome from './components/AccountingManagement/TrialBalance/TrialBalanceHome';
// Stock Management
import PresentStock from './components/StockManagement/PresentStock/PresentStock';
import LostAdjustment from './components/StockManagement/LostAdjustment/LostAdjustment';
import GainAdjustment from './components/StockManagement/GainAdjustment/GainAdjustment';
import NotFoundPage from './components/NotFound/NotFoundPage';

export default (
   <Route path="/" component={App} >
      <IndexRoute component={Dashboard} />
      <Route path="product" component={Product} >
         <IndexRoute component={ProductSearch} />
         <Route path="productMain/:productId" component={ProductMainHome} />
         <Route path="productMain/edit/:productId" component={ProductMainEdit} >
            <IndexRoute component={ProductMainEditGeneralInfoForm} />
            <Route path="price" component={ProductMainEditPriceForm} />
            <Route path="location" component={ProductMainEditLocation} />
            <Route path="feature" component={ProductMainEditFeature} />
            <Route path="image" component={ProductMainEditImage} />
         </Route >
         <Route path="productSub/:productId" component={ProductSubHome} />
         <Route path="productSub/edit/:productId" component={ProductSubEdit} >
            <IndexRoute component={ProductSubEditGeneralInfoForm} />
            <Route path="feature" component={ProductSubEditFeature} />
            <Route path="image" component={ProductSubEditImage} />
         </Route >
         <Route path="newProduct" component={NewProductHome} />
         <Route path="all" component={ProductHome} />
      </Route >
      <Route path="service" component={Service} >
         <IndexRoute component={ServiceHome} />
      </Route >
      <Route path="featureClass" component={FeatureClass} >
         <IndexRoute component={FeatureClassHome} />
      </Route >
      <Route path="shop" component={Shop} >
         <IndexRoute component={ShopHome} />
      </Route >
      <Route path="contact" component={Contact} >
         <IndexRoute component={ContactHome} />
         <Route path="newContact" component={NewContact} />
         <Route path="salesDue" component={SalesDue} />

         <Route path="detail/:contactId" component={ContactDetail} >
            {/*<IndexRoute component={ContactGeneral} />*/}
            <IndexRoute component={ContactAddress} />
            <Route path="invoice" component={ContactInvoice} >
               <IndexRoute component={ContactSaleInvoice} />
               <Route path="saleReturns" component={ContactSaleReturnInvoice} />
               <Route path="purchases" component={ContactPurchaseInvoice} />
               <Route path="expenses" component={ContactExpenseInvoice} />
               <Route path="fixedAssets" component={ContactFixedAssetsInvoices} />
            </Route >
            <Route path="stockItems" component={ContactStock} />
         </Route >

      </Route >
      <Route path="presentStock" component={PresentStock} />
      <Route path="lostAdjustment" component={LostAdjustment} />
      <Route path="gainAdjustment" component={GainAdjustment} />
      <Route path="findInvoice" component={FindInvoice} />

      {/*PurchaseHome*/}
      <Route path="purchase" component={Purchase} >
         <IndexRoute component={PurchaseHome} />
         <Route path="newPurchase" component={NewPurchase} />
         <Route path="editPurchase/:invoiceId" component={EditPurchaseForm} />
         <Route path="purchaseInvoiceDetail/:invoiceId" component={PurchaseInvoiceDetail} >
            <IndexRoute component={PurchaseInvoiceDetailItem} />
            <Route path="paymentHistory" component={PurchaseInvoiceDetailPaymentHistory} />
         </Route >
         <Route path="unpaidBill" component={UnpaidBill} />
         <Route path="unAuthorized" component={PurchaseUnAuthorized} />
         <Route path="purchasePayBill/:invoiceId" component={PurchasePayBill} />
      </Route >

      <Route path="purchaseReturn" component={PurchaseReturn} >
         <IndexRoute component={PurchaseReturnHome} />
         <Route path="newPurchaseReturn" component={NewPurchaseReturn} />
      </Route >
      <Route path="sale" component={Sale} >
         <IndexRoute component={SaleHome} />
         <Route path="newSale" component={NewSaleForm} />
         <Route path="editSaleForm/:invoiceId" component={EditSaleForm} />
         <Route path="saleInvoiceDetail/:invoiceId" component={SaleInvoiceDetail} >
            <IndexRoute component={SaleInvoiceDetailItem} />
            <Route path="paymentHistory" component={SaleInvoiceDetailPaymentHistory} />
         </Route >
         <Route path="saleInvoiceDetailOfficialLayout/:invoiceId" component={SaleInvoiceDetailOfficialLayout} />
         <Route path="saleDueBill" component={SaleDueBill} />
         <Route path="saleUnknownDueBill" component={SaleKnownDueBill} />
         <Route path="pendingBills" component={SalePendingBill} />
         <Route path="salePrepaidReceive/:invoiceId" component={SalePrepaidReceive} />
         <Route path="saleReceivePayment/:invoiceId" component={SaleReceivePayment} >
            <IndexRoute component={SaleFullPaymentForm} />
            <Route path="partialPayment" component={SalePartialPaymentForm} />
         </Route >

      </Route >
      <Route path="saleReturn" component={SaleReturn} >
         <IndexRoute component={SaleReturnHome} />
         <Route path="newSaleReturn" component={NewSaleReturn} />
         <Route path="saleReturnInvoiceDetail/:invoiceId" component={SaleReturnInvoiceDetail} >
            <IndexRoute component={SaleReturnInvoiceDetailItem} />
            <Route path="paymentHistory" component={SaleReturnInvoiceDetailPaymentHistory} />
         </Route >
         <Route path="dueBills" component={SaleReturnDueBill} />
         <Route path="saleReturnPayment/:invoiceId" component={SaleReturnPayment} >
            <IndexRoute component={SaleReturnFullPaymentForm} />
            <Route path="partialPayment" component={SaleReturnPartialPaymentForm} />
         </Route >
      </Route >

      <Route path="expense" component={Expense} >
         <IndexRoute component={ExpenseHome} />
         <Route path="new" component={NewExpenseForm} />
         <Route path="dueBills" component={ExpenseDueBill} />
         <Route path="expenseInvoiceDetail/:invoiceId" component={ExpenseInvoiceDetail} >
            <IndexRoute component={ExpenseInvoiceDetailItem} />
            <Route path="paymentHistory" component={ExpenseInvoiceDetailPaymentHistory} />
         </Route >
         <Route path="expensePayBill/:invoiceId" component={ExpensePayBill} >
            <IndexRoute component={ExpenseFullPaymentForm} />
            <Route path="partialPayment" component={ExpensePartialPaymentForm} />
         </Route >
      </Route >

      <Route path="fixedAsset" component={FixedAsset} >
         <IndexRoute component={FixedAssetHome} />
         <Route path="new" component={NewFixedAssetForm} />
         <Route path="fixedAssetInvoiceDetail/:invoiceId" component={FixedAssetInvoiceDetail} >
            <IndexRoute component={FixedAssetInvoiceDetailItem} />
            <Route path="paymentHistory" component={FixedAssetInvoiceDetailPaymentHistory} />
         </Route >
         <Route path="dueBills" component={FixedAssetDueBill} />
         <Route path="fixedAssetPayBill/:invoiceId" component={FixedAssetPayBill} >
            <IndexRoute component={FixedAssetFullPaymentForm} />
            <Route path="partialPayment" component={FixedAssetPartialPaymentForm} />
         </Route >
         <Route path="allFixedAssets" component={AllFixedAssets} />
      </Route >

      <Route path="order" component={Order} >
         <IndexRoute component={OrderHome} />
         <Route path="orderDetails/:id" component={OrderDetails} />
      </Route >

      <Route path="brand" component={Brand} >
         <IndexRoute component={BrandHome} />
         <Route path="new" component={NewBrandForm} />
         <Route path="edit/:id" component={EditBrandForm} />
      </Route >

      <Route path="manufacturer" component={Manufacturer} >
         <IndexRoute component={ManufacturerHome} />
         <Route path="new" component={NewManufacturerForm} />
         <Route path="edit/:id" component={EditManufacturerForm} />
      </Route >


      {/*Accounting Section*/}
      <Route path="journalEntry" component={JournalEntry} >
         <IndexRoute component={JournalEntryHome} />
         <Route path="newJournalEntry" component={NewJournalEntryForm} />
      </Route >
      <Route path="chartOfAccount" component={ChartOfAccount} >
         <IndexRoute component={ChartOfAccountHome} />
         <Route path="new" component={NewEditChartOfAccountForm} />
      </Route >
      <Route path="trialBalance" component={TrialBalance} >
         <IndexRoute component={TrialBalanceHome} />
      </Route >

      <Route path="*" component={NotFoundPage} />
   </Route >
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/